/** @jsxImportSource @emotion/react */

import { Button, Skeleton } from "antd";
import { BG_MAIN } from "assets/Common";
import { ModalCustom } from "components/Common/ModalCustom";
import { DataDetailCategoryType } from "contants/list-category-game";
import { handleLoginGame } from "helpers/handleLoginGame";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import React from "react";
import { useTranslation } from "react-i18next";
import { selectUsername } from "store/auth";
import { selectModalProps, selectOpenModal, setOpenModal } from "store/modal";
import { selectBalance, selectBalanceLoading } from "store/user";
import { StatusNotification } from "types";

import { LogoAuth } from "../LogoAuth";
import { PopupNoteVBOSStyle } from "./style";

interface Props {
  openNotification: (status: StatusNotification, message: string) => void;
}

const PopupNoteVBOS = ({ openNotification }: Props) => {
  const { t } = useTranslation(["messageModal", "button", "placeholder"]);
  const dispatch = useAppDispatch();
  const openModal = useAppSelector(selectOpenModal);
  const modalProps = useAppSelector(selectModalProps) as DataDetailCategoryType;
  const username = useAppSelector(selectUsername);
  const balanceUser = useAppSelector(selectBalance);
  const isLoadingBalance = useAppSelector(selectBalanceLoading);

  const handleOnclickItemGame = () => {
    handleLoginGame(
      {
        game_code: "",
        name: "",
        provider_code: modalProps.providerCode,
        type: "LT",
        featured: "",
        new_arrive: "",
        picture: "",
      },
      username,
      dispatch,
      openNotification,
      true
    );
    dispatch(setOpenModal(""));
  };

  return (
    <ModalCustom
      isOpenModal={openModal.includes("notify_VBOS")}
      handleCloseModal={() => dispatch(setOpenModal(""))}
      logoHeading
      headerBackground={BG_MAIN}
      heightBackground={75}
      bodyModal={
        <React.Fragment>
          <div css={PopupNoteVBOSStyle.wrapper}>
            <LogoAuth
              title={t("noteTitleVBOS", { title: modalProps.providerName })}
              showLogo={false}
            />
            <div className="thumbnail">
              <img src={modalProps.image} alt="..." />
            </div>
            <div className="title-provider">{t("placeholder:Lottery")}</div>
            <div className="balance">
              <span className="label">{t("placeholder:Coins")}:</span>
              {isLoadingBalance ? (
                <Skeleton.Input
                  active
                  style={{ minWidth: "60px", width: "100px" }}
                  block
                  size="small"
                />
              ) : (
                <span className="amount">{balanceUser.coins || "0.00"}</span>
              )}
            </div>
            <Button
              htmlType="button"
              css={PopupNoteVBOSStyle.buttonSubmit}
              onClick={handleOnclickItemGame}
            >
              {t("button:EnterGame")}
            </Button>
          </div>
        </React.Fragment>
      }
    />
  );
};
export default PopupNoteVBOS;
